export default {
    name: 'contact',
    type: 'document',
    title: 'Contact',
    fields: [
        {
            name: 'title',
            type: 'string',
            title: 'Title',
            readOnly: true,
            hidden: true,
        },
        {
            name: 'slug',
            type: 'slug',
            title: 'Slug',
            readOnly: true,
            hidden: true,
        },
        {
            title: 'Contacts',
            name: 'contacts',
            type: 'array',
            of: [{
                type: 'object', name: 'contact', fields: [
                    {
                        name: 'label',
                        type: 'string',
                        title: 'Label',
                        validation: Rule => Rule.required(),
                    },
                    {
                        name: 'email',
                        type: 'string',
                        title: 'Email',
                        validation: Rule => Rule.required(),
                    },
                ],
                preview: {
                    select: {
                        title: "label",
                        subtitle: "email",
                    },
                },
            }]
        },
        {
            name: 'policyTitle',
            type: 'string',
            title: 'Policy Title',
            validation: Rule => Rule.required(),
        },
    ]
}


// WEBPACK FOOTER //
// ./schemas/contact.js